/**
 * 消息提示框
 * 公用方法
 * @author fulh 2014年1月14日 11:48:42
 *
 * alert  :信息提示基础方法
 * close  :关闭提示
 * loading:加载提示
 * warn   :警告提示
 * success:成功提示
 * error  :错误提示
 */
$.module('MM.ui.messager', function () {
  var _tpl =
    '<div class="ui-messager-mask" id="ui-messager-mask-<%=id%>" \
	<%if(closable){%>onclick="MM.ui.messager.close(<%=id%>)"<%}%> ></div>\
        <div class="ui-messager fix"  id="ui-messager-<%=id%>">\
        <table>\
            <tr>\
                <td class="ui-messager-left"><span class="ui-messager-icon ui-messager-<%=icon%>"></span></td>\
                <td class="ui-messager-cnt"><%=msg%></td>\
            </tr>\
        </table></div>';
  var _ids = [];

  /**
   * 信息提示
   * @param  {object/string} option
   * @param  {string} icon    包含： info warn success error confirm
   * @return {object}            弹框对象
   */
  function _alert(option, icon) {
    // if (top != self) {
    //     return top.MM.ui.messager.alert(option, icon);
    // }

    _close();

    var _opt = option,
      settings = {
        time: 4,
        msg: '',
        closable: true, //是否可关闭
        callback: function () {},
        icon: '', //info warn success error confirm
        id: Math.floor(Math.random() * 100000),
      };
    if (typeof option == 'string') {
      _opt = { msg: option, icon: icon ? icon : 'info' };
    }

    if ($.isFunction(_opt.callback)) {
      _opt.callback = _opt.callback || function () {};
    }
    $.extend(settings, _opt);
    _ids.push(settings.id);

    $('body').append($.template(_tpl, settings));

    var $messager = $('#ui-messager-' + settings.id);

    $messager.css({
      left: '50%',
      marginLeft: -$messager.outerWidth() / 2,
    });
    if (_opt.icon == 'success' || _opt.icon == 'loading') {
      $messager.effect('fadeInDown');
    } else {
      $messager.effect('shake', 200);
    }

    if ($('.video-wrap').length > 0) {
      $messager.css({
        bottom: 'auto',
        top: $('.video-wrap').height() + 50,
      });
    }

    if (settings.time) {
      settings.timerID = setTimeout(function () {
        _close(settings.id);
      }, settings.time * 1000);
    }

    $messager.data('settings', settings);
    return $messager;
  }

  //关闭 弹框ID
  function _close(id) {
    var _id = id || _ids.pop();
    var $messager = $('#ui-messager-' + _id);
    if (!$messager.length) {
      return;
    }

    var settings = $messager.data('settings');
    //if (!settings.closable) {
    //	return;
    //}
    $messager.effect('fadeOutUp', function () {
      $('#ui-messager-mask-' + _id).remove();
      if (id) {
        _removeID(id);
      }

      if (settings) {
        settings.callback();
        if (settings.time) {
          clearTimeout(settings.timerID);
        }
      }
      $messager.remove();
    });

    //$("#ui-messager-" + _id).animate({
    //	left: '100%',
    //	marginLeft:0
    //}, "linear", function () {
    //	$(this).remove();
    //});
  }

  function _removeID(id) {
    for (var i = 0; i < _ids.length; i++) {
      if (_ids[i] == id) {
        _ids.splice(i, 1);
      }
    }
  }

  var _messager = {
    alert: _alert,
    loading: function (msg, callback) {
      return _alert({
        msg: msg || '正在努力加载……',
        icon: 'loading',
        callback: callback,
        time: 0,
        closable: false,
      });
    },
    close: _close,
  };

  //  eg:
  //  MM.ui.warn(msg, callback)    回调
  //  MM.ui.warn(msg, true)        不能关闭
  var _methods = ['warn', 'error', 'success'];
  (function () {
    for (var item in _methods) {
      var m = _methods[item];
      _messager[m] = (function (m) {
        return function (msg, callback) {
          if (callback == true) {
            return _alert({ msg: msg, icon: m, time: 0 });
          } else {
            return _alert({ msg: msg, icon: m, callback: callback });
          }
        };
      })(m);
    }
  })();

  return _messager;
});
